<template>
  <Container>
    <Typography as="h2" variant="header-2" class="mb-6 lg:mb-10">{{ header }}</Typography>
    <div class="col-span-12 mb-14 lg:mb-34">
      <LatestNewsList :news-items="items" />
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { RelatedNewsGridApiModel } from '@gro-up/api/corporate'
import { Container, Typography } from '@gro-up/ui/primitives';

import LatestNewsList from '~/components/NewsOverview/LatestNewsList.vue';

type RelatedNewsBlockProps = RelatedNewsGridApiModel

defineProps<RelatedNewsBlockProps>()
</script>
